import axios from 'axios'; 

class ApiService {
  constructor() {
    this._baseUrl = process.env.REACT_APP_API_URL;
    this._mediaBaseUrl = process.env.REACT_APP_S3_URL;
    this._audioBaseUrl = process.env.REACT_APP_AUDIO_URL;
    this._audioRadioBaseUrl = process.env.REACT_APP_RADIO_URL;
    this._audioSleepBaseUrl = process.env.REACT_APP_SLEEP_URL;
  }
  // constructor() {
  //   // this._baseUrl = 'https://api-zippy.help2engg.com/api/';
  //   // this._mediaBaseUrl = 'https://development-shambhavi.s3.ap-south-1.amazonaws.com/zippy/';
  //   // this._audioBaseUrl = 'https://playzippy.s3.ap-south-1.amazonaws.com/';
  //   // this._audioRadioBaseUrl = 'https://playzippy.s3.ap-south-1.amazonaws.com/7777/';
  //   this._baseUrl = 'https://api-zippy.help2engg.com/api/';
  //   this._mediaBaseUrl = 'https://playzippy.s3.amazonaws.com/zippy/';
  //   this._audioBaseUrl = 'https://playzippy.s3.amazonaws.com/';
  //   this._audioRadioBaseUrl = 'https://playzippy.s3.amazonaws.com/7777/';
  //   this._audioSleepBaseUrl = 'https://playzippy.s3.amazonaws.com/8888/';
  // }

  async createAuthorizationHeader(contentType = "application/json") {
    const token = localStorage.getItem('token') || '';
    const headers = {
      'Content-Type': contentType,
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
  }

  async fetchData(url) {
    try {
      const headers = await this.createAuthorizationHeader();
      const response = await axios.get(`${this._baseUrl}${url}`, { headers });
      return response.data;
    } catch (error) {
      throw new Error('Failed to load data');
    }
  }

  async postData(url, data, isMultipart = false) {
    try {
      const headers = await this.createAuthorizationHeader(
        isMultipart ? "multipart/form-data" : "application/json"
      );

      const response = await axios.post(`${this._baseUrl}${url}`, data, { headers });
      return response.data;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  }

  async putData(url, data, isMultipart = false) {
    try {
      const headers = await this.createAuthorizationHeader(
        isMultipart ? "multipart/form-data" : "application/json"

      );

      const response = await axios.put(`${this._baseUrl}${url}`, data, { headers });
      return response.data;
    } catch (error) {
      throw new Error('Failed to update data');
    }
  }

  async uploadFile(url, file) {
    try {
      const headers = await this.createAuthorizationHeader("multipart/form-data");
      const formData = new FormData();
      formData.append('files', file);

      const response = await axios.post(`${this._baseUrl}${url}`, formData, { headers });
      return response.data;
    } catch (error) {
      throw new Error(`Error uploading file: ${error.message}`);
    }
  }

  async deleteData(url) {
    try {
      const headers = await this.createAuthorizationHeader();
      const response = await axios.delete(`${this._baseUrl}${url}`, { headers });
      return response.data;
    } catch (error) {
      throw new Error('Failed to delete data');
    }
  }

  getFullImageUrl(imagePath) {
    return `${this._mediaBaseUrl}${imagePath}`;
  }
  getAudioUrl(imagePath) {
    return `${this._audioBaseUrl}${imagePath}`;
  }
  getAudioRadioUrl(imagePath) {
    return `${this._audioRadioBaseUrl}${imagePath}`;
  }
  getAudioSleepUrl(imagePath) {
    return `${this._audioSleepBaseUrl}${imagePath}`;
  }
}

export default new ApiService();
